<template>
  <v-container fluid class="custom-bthrust-dashboard pt-0">
    <v-row>
      <v-col md="12">
        <v-layout class="dashboard-top-button">
          <v-flex>
            <router-link
              :to="getDefaultRoute('customer.create')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Create Customer</router-link
            >
          </v-flex>
          <!-- <v-flex class="mx-4">
            <router-link
              to=""
              @click.native="createTransaction('quotation')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Create Quotation</router-link
            >
          </v-flex> -->
          <v-flex>
            <router-link
              :to="getDefaultRoute('equipment.create')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Create Vehicle</router-link
            >
          </v-flex>
          <v-flex v-if="false" class="mx-4">
            <router-link
              to=""
              @click.native="createTransaction('invoice')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Create Invoice</router-link
            >
          </v-flex>
          <v-flex>
            <router-link
              :to="getDefaultRoute('engineer.create')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Create Drivers
            </router-link>
          </v-flex>
          <v-flex class="ml-4" v-if="false">
            <router-link
              :to="getDefaultRoute('profile.setting')"
              class="btn btn-danger btn-shadow-hover font-weight-bolder w-100 font-size-18 dasboard-top-btn-font"
              >Settings</router-link
            >
          </v-flex>
        </v-layout>
      </v-col>
      <v-col md="4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-danger py-5 pb-2">
            <h3 class="card-title font-weight-bolder text-white">
              Transport Status
            </h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div
              id="kt_mixed_widget_1_chart"
              class="card-rounded-bottom bg-danger dashboard-total-jobs"
              style="min-height: 100px"
            ></div>
            <div class="card-spacer smallbxc_row">
              <!--begin::Row-->
              <div class="row m-0">
                <div class="col bg-light-warning ttbox rounded-xl mr-7">
                  <span
                    class="svg-icon svg-icon-3x svg-icon-warning d-block my-2"
                  >
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="$assetURL('media/custom-svg/ticket.svg')"
                    />
                    <!--end::Svg Icon-->
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="warning"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab : 'all'
                        },
                      })
                    "
                    class="text-warning font-weight-bold font-size-h6"
                    >Total Transports</router-link
                  >
                </div>
                <div class="col bg-light-primary ttbox rounded-xl">
                  <span
                    class="svg-icon svg-icon-3x svg-icon-primary d-block my-2"
                  >
                    <inline-svg
                      :src="$assetURL('media/custom-svg/tickets.svg')"
                    />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_new_delivery }}
                    </template>
                  </div>
                  <router-link
                     :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab : 'new'
                        },
                      })
                    "
                    class="text-primary font-weight-bold font-size-h6"
                    >Total New Transports</router-link
                  >
                </div>
              </div>
              <!--end::Row-->
              <!--begin::Row-->
              <div class="row">
                <div class="col bg-light-info ttbox rounded-xl mr-7">
                  <span class="svg-icon svg-icon-3x svg-icon-info d-block">
                    <inline-svg
                      :src="$assetURL('media/custom-svg/close-t.svg')"
                    />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="info"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_open_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab : 'open'
                        },
                      })
                    "
                    class="text-info font-weight-bold font-size-h6"
                    >Total Open Transports</router-link
                  >
                </div>
                <div class="col bg-light-success ttbox rounded-xl">
                  <span
                    class="svg-icon svg-icon-3x svg-icon-success d-block my-2"
                  >
                    <inline-svg
                      :src="$assetURL('media/custom-svg/delete.svg')"
                    />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="success"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_completed_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab: 'delivered',
                        },
                      })
                    "
                    class="text-success font-weight-bold font-size-h6"
                    >Total Completed Transports</router-link
                  >
                </div>
              </div>
              <!--end::Row-->

               <!--begin::Row-->
              <div class="row">
                <!-- <div class="col rounded-xl bg-light-orange ttbox mr-7" >
                  <span class="svg-icon svg-icon-3x svg-icon-info d-block">
                    <inline-svg
                      :src="$assetURL('media/custom-svg/close-t.svg')"
                    />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="info"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_hold_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab: 'hold',
                        },
                      })
                    "
                    class="text-info font-weight-bold font-size-h6"
                    >Total Hold Transports</router-link
                  >
                </div> -->
                <div class="col ttbox rounded-xl bg-light-danger" >
                  <span
                    class="svg-icon svg-icon-3x svg-icon-success d-block my-2"
                  >
                    <inline-svg
                      :src="$assetURL('media/custom-svg/delete.svg')"
                    />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="success"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_inprogress_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('outgoing-delivery', {
                        query: {
                          tab: 'inprogress',
                        },
                      })
                    "
                    class="text-success font-weight-bold font-size-h6"
                    >Total Enroute Transports</router-link
                  >
                </div>
              </div>
              <!--end::Row-->

              <!--begin::Row-->
            <!--  <div class="row m-0">
                <div class="col bg-light-danger ttbox rounded-xl">
                  <span class="svg-icon svg-icon-3x svg-icon-danger d-block">
                    <inline-svg :src="$assetURL('media/custom-svg/tt1.svg')" />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="red"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ deliveryStatusCount.total_hold_delivery }}
                    </template>
                  </div>
                  <router-link
                    :to="
                      getDefaultRoute('visit', {
                        query: {
                          status: 'all',
                          tab: 'overdue',
                        },
                      })
                    "
                    class="text-danger font-weight-bold font-size-h6"
                    >Total Hold Delivery</router-link
                  >
                </div>
                <div v-if="false" class="col bg-light-warning ttbox rounded-xl">
                  <span class="svg-icon svg-icon-3x svg-icon-success d-block">
                    <inline-svg :src="$assetURL('media/custom-svg/bug.svg')" />
                  </span>
                  <div class="ttnumbr">
                    <template v-if="countLoading">
                      <v-progress-circular
                        indeterminate
                        color="success"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ bugCount }}
                    </template>
                  </div>
                  <router-link
                    :to="getDefaultRoute('bug.report')"
                    class="text-success font-weight-bold font-size-h6"
                    >Bug Reports</router-link
                  >
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <!--end::Mixed Widget 1-->
      </v-col>
      <v-col md="4">
        <div class="card dash_card card-custom gutter-b">
          <div class="card-body p-0">
            <div class="cardtopbar">
              <div
                class="float-right custom-menu-select py-1 btn btn-success btn-shadow-hover"
              >
                <v-select
                  :items="durationList"
                  v-model="customerDuration"
                  hide-details
                  :disabled="customerCountLoading"
                  item-color="cyan"
                  color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getCustomerCount"
                >
                </v-select>
              </div>
              <h4>CUSTOMERS</h4>
              <span class="text-black mt-3 font-weight-400 font-size-sm"
                >You have
                <template v-if="customerCountLoading">
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  {{ customerCount.count }}
                </template>
                new customers {{ lodash.lowerCase(customerDuration) }}</span
              >
            </div>
            <div
              id="kt_stats_widget_11_chart"
              class="card-rounded-bottom mid_part"
              data-color="danger"
            >
              <div
                class="d-flex align-items-center justify-content-between card-spacer pb-2 flex-grow-1"
              >
                <span
                  class="symbol symbol-circle symbol-50 symbol-light-danger mr-2"
                >
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-xl svg-icon-success">
                      <inline-svg
                        :src="$assetURL('media/custom-svg/men.svg')"
                      />
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-column text-right">
                  <span class="qnt_val font-weight-bolder text-success">
                    <template v-if="customerCountLoading">
                      <v-progress-circular
                        indeterminate
                        color="success"
                      ></v-progress-circular>
                    </template>
                    <template v-else>{{ customerCount.percentage }} %</template>
                  </span>
                  <span class="text-muted font-weight-bold mt-2"
                    >more than
                    {{
                      lodash.replace(
                        lodash.lowerCase(customerDuration),
                        "this",
                        "last"
                      )
                    }}</span
                  >
                </div>
              </div>
              <div class="active_mem">
                <ul>
                  <li>
                    All Customers
                    <span class="bg-light-warning">
                      <template v-if="customerCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="warning"
                        ></v-progress-circular>
                      </template>
                      <template v-else>
                        {{ customerCount.all_customers }}
                      </template>
                    </span>
                  </li>
                  <li>
                    Active Customers
                    <span class="bg-light-success"
                      ><template v-if="customerCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="success"
                        ></v-progress-circular>
                      </template>
                      <template v-else>
                        {{ customerCount.active_customers }}
                      </template></span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card dash_card card-custom gutter-b">
          <div class="card-body p-0">
            <div class="cardtopbar">
              <div
                class="float-right custom-menu-select py-1 btn btn-warning btn-shadow-hover"
              >
                <v-select
                  :items="durationList"
                  v-model="jobDuration"
                  hide-details
                  :disabled="deliveryCountLoading"
                  item-color="cyan"
                  color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getDeliveryCount"
                >
                </v-select>
              </div>
              <h4>TRANSPORTS</h4>
              <span class="text-black mt-3 font-weight-400 font-size-sm"
                >You have
                <template v-if="deliveryCountLoading">
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  {{ deliveryCount.count }}
                </template>
                new delivery scheduled for
                {{ lodash.lowerCase(jobDuration) }}</span
              >
            </div>
            <div
              id="kt_stats_widget_11_chart"
              class="card-rounded-bottom mid_part"
              data-color="danger"
            >
              <div
                class="d-flex align-items-center justify-content-between card-spacer pb-2 flex-grow-1"
              >
                <span
                  class="symbol symbol-circle symbol-50 symbol-light-danger mr-2"
                >
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-xl svg-icon-warning">
                      <inline-svg
                        :src="$assetURL('media/custom-svg/ticket.svg')"
                      />
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-column text-right">
                  <span class="qnt_val font-weight-bolder text-warning">
                    <template v-if="deliveryCountLoading">
                      <v-progress-circular
                        indeterminate
                        color="warning"
                      ></v-progress-circular>
                    </template>
                    <template v-else>{{ deliveryCount.percentage }} %</template>
                  </span>
                  <span class="text-muted font-weight-bold mt-2"
                    >more than
                    {{
                      lodash.replace(
                        lodash.lowerCase(jobDuration),
                        "this",
                        "last"
                      )
                    }}</span
                  >
                </div>
              </div>
              <div class="active_mem">
                <ul>
                  <li>
                    All Transports
                    <span class="bg-light-warning">
                      <template v-if="deliveryCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="warning"
                        ></v-progress-circular>
                      </template>
                      <template v-else>
                        {{ deliveryCount.all_deliveries }}
                      </template>
                    </span>
                  </li>
                 <!-- <li>
                    Recurring Visits
                    <span class="bg-light-success"
                      ><template v-if="deliveryCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="success"
                        ></v-progress-circular>
                      </template>
                      <template v-else>
                        {{ deliveryCount.recurring_jobs }}
                      </template></span
                    >
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      
      <v-col md="4">
        <div v-if="false" class="card card-custom gutter-b dash_card">
          <div class="card-body p-0">
            <div class="cardtopbar">
              <div
                class="float-right custom-menu-select py-1 btn btn-primary btn-shadow-hover"
              >
                <v-select
                  :items="durationList"
                  v-model="quotationDuration"
                  hide-details
                  :disabled="quotationCountLoading"
                  item-color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getQuotationCount"
                >
                </v-select>
              </div>
              <h4>INVOICES</h4>
              <span class="text-black mt-3 font-weight-400 font-size-sm"
                >You have
                <template v-if="quotationCountLoading">
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  {{ quotationCount.count }}
                </template>
                new invoices {{ lodash.lowerCase(quotationDuration) }}</span
              >
            </div>
            <div
              id="kt_stats_widget_11_chart"
              class="card-rounded-bottom mid_part"
              data-color="danger"
            >
              <div
                class="d-flex align-items-center justify-content-between card-spacer pb-2 flex-grow-1"
              >
                <span
                  class="symbol symbol-circle symbol-50 symbol-light-danger mr-2"
                >
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-xl svg-icon-primary">
                      <inline-svg
                        :src="$assetURL('media/custom-svg/clipboard.svg')"
                      />
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-column text-right">
                  <span class="qnt_val font-weight-bolder text-primary">
                    <template v-if="quotationCountLoading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </template>
                    <template v-else
                      >{{ quotationCount.percentage }} %</template
                    >
                  </span>
                  <span class="text-muted font-weight-bold mt-2"
                    >more than
                    {{
                      lodash.replace(
                        lodash.lowerCase(quotationDuration),
                        "this",
                        "last"
                      )
                    }}</span
                  >
                </div>
              </div>
              <div class="active_mem">
                <ul>
                  <li>
                    Average Revenue
                    <span class="bg-light-success"
                      ><template v-if="quotationCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="success"
                        ></v-progress-circular>
                      </template>
                      <template v-else>
                        {{ quotationCount.average_revenue }}
                      </template></span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-custom gutter-b dash_card">
          <div class="card-body p-0">
            <div class="cardtopbar">
              <h4>TRANSPORTS DUE TIMES</h4>
            </div>
            <div
              id="kt_stats_widget_11_chart"
              class="card-rounded-bottom mid_part"
              data-color="danger"
            >
              <div
                class="dash_bottom d-flex align-items-center justify-content-between card-spacer pb-2 flex-grow-1"
              >
                <span
                  class="symbol symbol-circle symbol-50 symbol-light-danger mr-2"
                >
                  <span class="symbol-label">
                    <span class="svg-icon svg-icon-xl svg-icon-danger">
                      <inline-svg
                        :src="$assetURL('media/custom-svg/clock.svg')"
                      />
                    </span>
                  </span>
                </span>
                <div class="d-flex flex-column text-right v_list">
                  <ul>
                    <li>
                      <span class="svg-icon svg-icon-xl svg-icon-danger">
                        <inline-svg
                          :src="$assetURL('media/custom-svg/right.svg')"
                        />
                      </span>
                      <strong>En-Route</strong>
                      <div class="vdnum" v-if="deliveryDueCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="red"
                        ></v-progress-circular>
                      </div>
                      <span v-else>
                        {{ deliveryDueTimes.in_progress }}
                      </span>
                    </li>
                    <li>
                      <span class="svg-icon svg-icon-xl svg-icon-danger">
                        <inline-svg
                          :src="$assetURL('media/custom-svg/right.svg')"
                        />
                      </span>
                      <strong>Today</strong>
                      <div class="vdnum" v-if="deliveryDueCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="red"
                        ></v-progress-circular>
                      </div>
                      <span v-else>
                        {{ deliveryDueTimes.today }}
                      </span>
                    </li>
                    <li>
                      <span class="svg-icon svg-icon-xl svg-icon-danger">
                        <inline-svg
                          :src="$assetURL('media/custom-svg/right.svg')"
                        />
                      </span>
                      <strong>Tomorrow</strong>
                      <div class="vdnum" v-if="deliveryDueCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="red"
                        ></v-progress-circular>
                      </div>
                      <span v-else>
                        {{ deliveryDueTimes.tomorrow }}
                      </span>
                    </li>
                    <li>
                      <span class="svg-icon svg-icon-xl svg-icon-danger">
                        <inline-svg
                          :src="$assetURL('media/custom-svg/right.svg')"
                        />
                      </span>
                      <strong>This week</strong>
                      <div class="vdnum" v-if="deliveryDueCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="red"
                        ></v-progress-circular>
                      </div>
                      <span v-else>
                        {{ deliveryDueTimes.this_week }}
                      </span>
                    </li>
                    <li>
                      <span class="svg-icon svg-icon-xl svg-icon-danger">
                        <inline-svg
                          :src="$assetURL('media/custom-svg/right.svg')"
                        />
                      </span>
                      <strong>Upcoming</strong>
                      <div class="vdnum" v-if="deliveryDueCountLoading">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="red"
                        ></v-progress-circular>
                      </div>
                      <span v-else>
                        {{ deliveryDueTimes.upcoming }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-custom gutter-b dash_card">
          <div class="card-body p-0 ">
            <div class="cardtopbar pb-3">
               <div
                class="float-right custom-menu-select py-1 btn btn-success btn-shadow-hover"
              >
                  <v-select
                  :menu-props="{offsetY: true}"
                  :items="durationList"
                  v-model="driverPerformanceDuration"
                  hide-details
                  :disabled="driverCountLoading"
                  item-color="cyan"
                  color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getDriverData"
                >
                  </v-select>
              </div>
              <h4>Driver Performance</h4>
             
            </div>

            <template v-if="driverCountLoading">
              <div class="d-flex justify-center align-center" style="height: 150px;">
                <v-progress-circular
                  indeterminate
                  color="warning"
                  size="50"
                ></v-progress-circular>
              </div>
            </template>
          
            <div
              v-else
              id="kt_stats_widget_11_chart"
              class="card-rounded-bottom mid_part"
              data-color="danger"
            >
               <div class="px-5">
                

                  <v-card
                    v-for="(row, i) in drivers"
                    :key="i"
                    :class="`mb-3 pa-3 rounded-lg ${row.bg} lighten-5`"
                    elevation="0"
                  >
      
                  <div class="d-flex align-center" 
                   v-on:click="routeToDriver(row.id)"
                   style="cursor: pointer;"
                  >
                    <v-avatar
                      color="white"
                      width="50"
                      height="50"
                      class="elevation-0 mr-3"
                    >
                      <v-img :src="row.profile"></v-img>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium font-size-15">{{ row.name }}</div>
                      <div class="text-caption-1 text-grey-darken-1"><v-chip small color="blue" label outlined>{{ row.driverId }}</v-chip></div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex flex-column justify-content between align-end">
                
                  <div class="d-flex align-center mb-0">
                    <span class="font-weight-medium text-grey-darken-1 mr-2">Total Trips:</span>
                      <span class="text-subtitle-1 font-weight-medium mt-1" :class="`${row.statusColor}--text`">
                        {{ row.totalTrips }}
                      </span>
                  </div>

                  <div class="d-flex align-center">
                    <span class="font-weight-medium text-grey-darken-1 mr-2">Completed Trips:</span>
                      <span class="text-subtitle-1 font-weight-medium green--text mt-1">
                        {{ row.completedTrips }}
                      </span>
                  </div>
                </div>
                  </div>
                </v-card>
                </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col md="12" sm="12" class="{'d-none': !overdue_visits}" v-if=false>
        <DashboardVisits
          v-on:init-component="overdue_visits = true"
        ></DashboardVisits>
      </v-col>
      <v-col md="12" sm="12" v-if=false>
        <Equipment
          :detail="{}"
          type="dashboard"
        ></Equipment>
      
      </v-col>
      <v-col md="6" sm="12">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title justify-space-between width-100">
              <h3 class="card-label">PRIORITY-WISE Transports</h3>
              <div
                class="text-right custom-menu-select py-1 btn btn-primary btn-shadow-hover"
              >
                <v-select
                  :items="durationList"
                  v-model="priorityDuration"
                  hide-details
                  :disabled="priorityCountLoading"
                  item-color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getPriorityGraph"
                >
                </v-select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <template v-if="priorityCountLoading">
              <div class="min-height-400px d-flex align-center">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </template>
            <template v-else>
              <apexchart
                height="455"
                type="area"
                :options="priorityChartoptions"
                :series="prioritySeries"
              ></apexchart>
            </template>
          </div>
        </div>
      </v-col>
      <!-- <v-col md="6" sm="12">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title justify-space-between width-100">
              <h3 class="card-label">ISSUE-WISE VISITS</h3>
              <div
                class="text-right custom-menu-select py-1 btn btn-primary btn-shadow-hover"
              >
                <v-select
                  :items="durationList"
                  v-model="issueDuration"
                  hide-details
                  :disabled="issueCountLoading"
                  item-color="cyan"
                  class="pt-0 mt-0"
                  v-on:change="getIssueGraph"
                >
                </v-select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <template v-if="issueCountLoading">
              <div class="min-height-400px d-flex align-center">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </template>
            <template v-else>
              <apexchart
                height="468"
                type="pie"
                :options="issueChartoptions"
                :series="issueSeries"
              ></apexchart>
            </template>
          </div>
        </div>
      </v-col> -->
    </v-row>
    <template>
      <template v-if="customerDialog">
        <CustomerDialog
          :customerDialog="customerDialog"
          v-on:closeDialog="closeDialog"
          v-on:resetAll="resetAll"
          v-on:selectCustomer="selectCustomer"
          v-on:selectCustomerPerson="selectCustomerPerson"
          v-on:selectCustomerProperty="selectCustomerProperty"
          v-on:selectCustomerBilling="selectCustomerBilling"
        ></CustomerDialog>
      </template>
      <template v-if="customerPersonDialog">
        <CustomerPersonDialog
          :customerPersonDialog="customerPersonDialog"
          :customer="customer"
          v-on:closeDialog="closeDialog"
          v-on:resetAll="resetAll"
          v-on:selectCustomerPerson="selectCustomerPerson"
        ></CustomerPersonDialog>
      </template>
      <template v-if="customerPropertyDialog">
        <CustomerPropertyDialog
          :customerPropertyDialog="customerPropertyDialog"
          :customer="customer"
          v-on:closeDialog="closeDialog"
          v-on:resetAll="resetAll"
          v-on:selectCustomerProperty="selectCustomerProperty"
        ></CustomerPropertyDialog>
      </template>
    </template>
  </v-container>
</template>

<style scoped src="@/assets/sass/dashboard.scss" lang="scss"></style>
<script>
const colorPalette = ["#00D8B6", "#008FFB", "#FEB019", "#FF4560", "#775DD0"];

import { GET, QUERY } from "@/core/services/store/request.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";
import CustomerPropertyDialog from "@/view/pages/partials/Select-Customer-Property.vue";
import DashboardVisits from "@/view/pages/partials/Dashboard-Visits.vue";
import Equipment from "@/view/pages/partials/Detail/Equipment";

export default {
  name: "dashboard",
  data() {
    return {
      customer: 0,
      customerPerson: 0,
      customerProperty: 0,
      customerBilling: 0,
      customerDialog: false,
      customerPersonDialog: false,
      customerPropertyDialog: false,
      transactionType: null,
      overdue_visits: false,
      prioritySeries: [],
      drivers: [],
      priorityChartoptions: {
        stroke: {
          curve: "straight",
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          followCursor: true,
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
      },
      issueSeries: [],
      issueChartoptions: {
        dataLabels: {
          enabled: false,
        },
        colors: colorPalette,
        labels: [],
        legend: {
          position: "left",
        },
      },
      driverPerformanceDuration : "this_month",
      issueDuration: "this_month",
      issueCountLoading: false,
      priorityDuration: "this_month",
      priorityCountLoading: false,
      countLoading: true,
      customerCountLoading: true,
      deliveryCountLoading: true,
      driverCountLoading : true,
      quotationCountLoading: true,
      deliveryDueCountLoading : false,
      durationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "This Year", value: "this_year" },
      ],
      customerDuration: "this_month",
      jobDuration: "this_month",
      quotationDuration: "this_month",
      bugCount: 0,
      customerCount: {
        count: 0,
        all_customers: 0,
        active_customers: 0,
        percentage: 0,
      },
      quotationCount: {
        count: 0,
        percentage: 0,
        average_revenue: 0,
      },

      deliveryCount: {
        count: 0,
        all_jobs: 0,
        percentage: 0,
      },

      deliveryDueTimes :
      {
         total_in_progress: 0,
         total_today : 0,
         total_tomorrow: 0,
         total_this_week: 0,
         total_up_coming: 0,
      },
      
      deliveryStatusCount: {
        total_delivery: 0,
        total_new_delivery: 0,
        total_open_delivery: 0,
        total_failed_delivery : 0,
        total_completed_delivery: 0,
        total_inprogress_delivery: 0,
        total_hold_delivery: 0,
      },
      visitCount: {
        total_visits: 0,
        total_open_visits: 0,
        total_overdue_visits: 0,
        total_today_visits: 0,
        total_tomorrow_visits: 0,
        total_this_week_visits: 0,
        total_upcomming_visits: 0,
        total_inprogress_visits: 0,
        total_hold_visits: 0,
        total_completed_visits: 0,
        total_cancelled_visits: 0,
      },
    };
  },
  methods: {

     routeToDriver(id) {
      this.$router.push({
        name: "admin.engineer.detail",
        params: { id },
      });
    },

    createTransaction(type) {
      this.transactionType = type;
      this.customerDialog = true;
    },
    resetAll() {
      this.customer = 0;
      this.customerPerson = 0;
      this.customerProperty = 0;
      this.closeDialog();
    },
    closeDialog() {
      this.customerDialog = false;
      this.customerPersonDialog = false;
      this.customerPropertyDialog = false;
    },
    selectCustomer(param) {
      this.customer = param;
      this.closeDialog();
      this.checkTransactionType();
      if (!this.customerPerson || this.customerPerson <= 0) {
        this.customerPersonDialog = true;
      } else {
        this.customerPropertyDialog = true;
      }
    },
    selectCustomerPerson(param) {
      this.customerPerson = param;
      this.closeDialog();
      this.checkTransactionType();
      if (
        (!this.customerProperty || this.customerProperty <= 0) &&
        this.transactionType != "quotation"
      ) {
        this.customerPropertyDialog = true;
      }
    },
    selectCustomerProperty(param) {
      this.customerProperty = param;
      this.closeDialog();
      this.checkTransactionType();
    },
    selectCustomerBilling(param) {
      this.customerBilling = param;
      this.closeDialog();
      this.checkTransactionType();
    },
    checkTransactionType() {
      const _this = this;
      if (_this.transactionType === "quotation") {
        if (
          _this.customer > 0 &&
          _this.customerPerson > 0 &&
          _this.customerBilling > 0
        ) {
          _this.$router.push(
            _this.getDefaultRoute("quotation.create", {
              query: {
                customer: _this.customer,
                contact_person: _this.customerPerson,
                billing: _this.customerBilling,
              },
            })
          );
        }
      } else {
        if (
          _this.customer > 0 &&
          _this.customerPerson > 0 &&
          _this.customerProperty > 0
        ) {
          _this.$router.push(
            _this.getDefaultRoute(_this.transactionType + ".create", {
              query: {
                customer: _this.customer,
                contact_person: _this.customerPerson,
                property: _this.customerProperty,
              },
            })
          );
        }
      }
    },
    getDashboardCount() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, {
              url: "dashboard-count",
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDashboardCustomerCount() {
      const _this = this;
      _this.customerCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-customer",
              data: {
                duration: _this.customerDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

     getDashboardDriverData() {
      const _this = this;
      _this.driverCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-driver-delivery-count",
              data: {
                duration: _this.driverPerformanceDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },


    getDashboardDeliveryCount() {
      const _this = this;
      _this.deliveryCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-delivery",
              data: {
                duration: _this.jobDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDashboardQuotationCount() {
      const _this = this;
      _this.quotationCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-quotation",
              data: {
                duration: _this.quotationDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDashboardPriorityCount() {
      const _this = this;
      _this.priorityCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-priority-graph",
              data: {
                duration: _this.priorityDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDashboardIssueCount() {
      const _this = this;
      _this.issueCountLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "dashboard-issue-graph",
              data: {
                duration: _this.issueDuration,
              },
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getCustomerCount() {
      const _this = this;
      _this
        .getDashboardCustomerCount()
        .then(({ customer }) => {
          if (customer) {
            _this.customerCount = customer;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.customerCountLoading = false;
        });
    },

     getDriverData() {
      const _this = this;
      _this
        .getDashboardDriverData()
        .then(({drivers}) => {
          if (drivers) {
            _this.drivers = drivers;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.driverCountLoading = false;
        });
    },


    getDeliveryCount() {
      const _this = this;
      _this
        .getDashboardDeliveryCount()
        .then(({ delivery }) => {
          if (delivery) {
            _this.deliveryCount = delivery;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deliveryCountLoading = false;
        });
    },

  
     async getDeliveryDueCount() {

      this.deliveryDueCountLoading = true;

      try {
        const response = await this.$store.dispatch(GET, {
          url: "dashboard-delivery-due",
        });

        if (response.data) {
           this.deliveryDueTimes = response.data?.due_delivery;
        }
      } catch (error) {
        console.error("Error fetching job type:", error);
      }
      finally
      {
        this.deliveryDueCountLoading = false;
      }
    },

    
    getQuotationCount() {
      const _this = this;
      _this
        .getDashboardQuotationCount()
        .then(({ quotation }) => {
          if (quotation) {
            _this.quotationCount = quotation;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.quotationCountLoading = false;
        });
    },
    getPriorityGraph() {
      const _this = this;
      _this
        .getDashboardPriorityCount()
        .then(({ categories, prioritySeries }) => {
          if (categories) {
            _this.priorityChartoptions.xaxis.categories = categories;
          }
          if (prioritySeries) {
            _this.prioritySeries = prioritySeries;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.priorityCountLoading = false;
        });
    },
    getIssueGraph() {
      const _this = this;
      _this
        .getDashboardIssueCount()
        .then(({ issueSeries, labels }) => {
          if (labels) {
            _this.issueChartoptions.labels = labels;
          }
          if (issueSeries) {
            _this.issueSeries = issueSeries;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.issueCountLoading = false;
        });
    },
  },
  components: {
    CustomerDialog,
    DashboardVisits,
    CustomerPersonDialog,
    CustomerPropertyDialog,
    Equipment
  },
  mounted() {
    const _this = this;
    _this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Dashboard",
      },
    ]);
    _this.getCustomerCount();
    _this.getDeliveryCount();
    _this.getPriorityGraph();
    _this.getDeliveryDueCount();
    _this.getDriverData(); 
    _this.getQuotationCount();
    _this.getIssueGraph();
    _this
      .getDashboardCount()
      .then(({ delivery, visit, bug }) => {
        if (delivery) {
          _this.deliveryStatusCount = delivery;
        }
        if (visit) {
          _this.visitCount = visit;
        }
        if (bug) {
          _this.bugCount = bug;
        }
      })
      .catch((error) => {
        _this.logError(error);
      })
      .finally(() => {
        _this.countLoading = false;
      });
  },
};
</script>
